import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20diverse%20fashion%20products%20on%20a%20warm%20terracotta%20textured%20surface%2C%20sneakers%2C%20watch%2C%20sunglasses%2C%20bag%2C%20and%20clothing%20items%20arranged%20organically%2C%20natural%20sunlight%20creating%20soft%20highlights%2C%20editorial%20fashion%20photography%2C%20rich%20earthy%20orange%20and%20brown%20tones%2C%20vibrant%20and%20warm%20composition&width=1800&height=800&seq=hero-main-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet curated fashion products collection"
          title="Sugargoo Spreadsheet Fashion Collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <Navbar />

      <div className="relative z-10 w-full min-h-[420px] md:min-h-[600px] flex flex-col items-center justify-center text-center px-4 pt-20 pb-12 md:pt-24 md:pb-16">
        <p className="text-background-50/80 text-sm md:text-base font-medium tracking-widest uppercase mb-4">
          Curated Shopping Intelligence
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-3xl">
          Curated<br />Spreadsheet<br />Shopping Guide
        </h1>
        <p className="mt-5 text-background-50/85 text-sm md:text-base max-w-lg leading-relaxed">
          Discover the best Sugargoo spreadsheet collections — hand-picked products across every category, updated weekly for quality-conscious shoppers.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
          >
            Explore Categories
          </a>
          <Link
            to="/blog/sugargoo-spreadsheet-guide"
            className="whitespace-nowrap px-7 py-3 border border-background-50/50 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-colors cursor-pointer"
          >
            Read Guide
          </Link>
        </div>
      </div>
    </section>
  );
}